import Vue from "vue";
import {PersonnelService} from "@/common/api.service";
import {FETCH_JOB, FETCH_JOB_LIST, SAVE_EDITED_JOB, SAVE_NEW_JOB} from "./actions.js";
import {FETCH_JOB_LIST_END, RESET_DEFAULT_JOB_TO_EDIT, RESET_DEFAULT_NEW_JOB, SET_JOB, UPDATE_ADD_JOB_FIELD, UPDATE_JOB_FIELD, UPDATE_MANAGE_JOB_FIELD} from "./mutations.js";
import {LOAD_JOB_TO_EDIT, TOGGLE_EDIT_JOB_DIALOG, TOGGLE_NEW_JOB_DIALOG} from "./mutations";
import {SET_TOASTER_MESSAGE,} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        job: {},
        jobList: [],
        editStateJob: {
            name: false,
        },
        fatalFetchError: {
            state: false,
            value: "",
        },
        defaultJob: {
            name: '',
            isLive: true
        },
        addJobDialog: false,
        editJobDialog: false,
        editJob: {
            name: ''
        },
        addJob: {
            name: '',
            isLive: true
        }
    }
};

const state = getDefaultState();

const getters = {
    job(state) {
        return state.job;
    },
    jobList(state) {
        return state.jobList;
    },
    jobListForTable(state, getters) {

        const jobListForTable = state.jobList;

        jobListForTable.forEach(function (item, key) {

            let countOfPersonnelWithJob = getters.personnelWithJobCount(item.jobId);
            //
            // if (jobName == undefined) {
            //     jobName = "No Current Employment"
            // }

            jobListForTable[key]['personnelCount'] = countOfPersonnelWithJob;
        });
        return jobListForTable;
    },
    liveJobList(state) {
        let sortedJobList = state.jobList;

        sortedJobList = sortedJobList.filter(function (itm) {
            return itm.isLive == true;
        });

        sortedJobList = sortedJobList.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
        // console.log(sortedJobList);
        return sortedJobList;
    },
    editStateJob(state) {
        return state.editStateJob;
    },
    getJobNameById: (state) => (jobId) => {

        const job = state.jobList.find(job => job.jobId == jobId);
        if (job) {
            // console.log(job.name);
            return job.name;
        }

    },
};

const actions = {
    [FETCH_JOB_LIST]({commit}) {
        return PersonnelService.getAllJobs()
            .then(({data}) => {
                commit(FETCH_JOB_LIST_END, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [FETCH_JOB]({commit}, jobId) {
        return PersonnelService.getJob(jobId)
            .then(({data}) => {
                commit(SET_JOB, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [SAVE_EDITED_JOB]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedJob = state.editJob;
        return PersonnelService.updateJob(editedJob)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_JOB_TO_EDIT);
                dispatch(FETCH_JOB_LIST);
                return data;
            });
    },
    [SAVE_NEW_JOB]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newJob = state.addJob;
        return PersonnelService.saveNewJob(newJob)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_JOB_LIST);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Job failed to save'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [RESET_DEFAULT_NEW_JOB](state) {
        state.addJob = getDefaultState().defaultJob;
    },
    [TOGGLE_EDIT_JOB_DIALOG](state) {
        state.editJobDialog = !state.editJobDialog;
    },
    [TOGGLE_NEW_JOB_DIALOG](state) {
        state.addJobDialog = !state.addJobDialog;
    },
    [LOAD_JOB_TO_EDIT](state, jobId) {
        state.editJob = state.jobList.find((list) => list.jobId == jobId);
    },
    [UPDATE_ADD_JOB_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addJob[data.objectKey][0][data.key] = data.value;
        } else {
            state.addJob[data.key] = data.value;
        }
    },
    [UPDATE_JOB_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editJob[data.objectKey][0][data.key] = data.value;
        } else {
            state.editJob[data.key] = data.value;
        }
    },
    [UPDATE_MANAGE_JOB_FIELD](state, data) {
        state.job[data.field] = data.value;
    },
    [FETCH_JOB_LIST_END](state, data) {
        state.jobList = data;
    },
    [SET_JOB](state, data) {
        state.job = data;
    },
    [RESET_DEFAULT_JOB_TO_EDIT](state) {
        state.editJob = getDefaultState().defaultJob;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
